import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query PopularBikes($locale: String, $organisationId: ID, $schemeType: ID!) {
    storeHomePopularBikesData(locale: $locale, organisationId: $organisationId, schemeType: $schemeType) {
      employeeOrganisation {
        id
        scheme {
          id
          brochureGroups {
            id
            term
          }
          bikeDepartmentId
          popularBikes {
            brochureGroupId
            image
            price
            totalAmount
            productTagName
            productTagImage
            term
            brand
            variant
            category
            sku
            department
            name
            id
            productId
            productImages
            url
          }
        }
      }
    }
  }
`
export const getPopularBikesQueryKey = getQueryNames(query)[0]
export const popularBikesQuery = query
